import React from "react";
import { Outlet } from "react-router-dom";
import NewNav from "../NewNav";
import Footer from "../Footer";

const MainLayout: React.FC = () => {
  return (
    <>
      <NewNav />
      <Outlet />
      <Footer />
    </>
  );
};

export default MainLayout;
